(function () {
  'use strict';

  /* ── Storage ── */
  var STORAGE_KEY = 'lenz_wishlist_v1';
  var WL = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) { return []; }
    },
    save: function (arr) { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); },
    has: function (h) { return this.get().indexOf(h) > -1; },
    add: function (h) { var a = this.get(); if (a.indexOf(h) < 0) { a.push(h); this.save(a); } },
    remove: function (h) { this.save(this.get().filter(function (x) { return x !== h; })); },
    toggle: function (h) { if (this.has(h)) { this.remove(h); return false; } this.add(h); return true; },
    count: function () { return this.get().length; }
  };

  /* ── SVG ── */
  function heartSVG(filled) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"' +
      ' fill="' + (filled ? 'currentColor' : 'none') + '"' +
      ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
      '</svg>';
  }

  /* ── Custom event ── */
  function dispatchChange() {
    document.dispatchEvent(new CustomEvent('lenz:wishlist:change', { detail: { count: WL.count() } }));
  }

  /* ── Update a card button's state ── */
  function refreshBtn(btn) {
    var active = WL.has(btn.dataset.handle);
    btn.classList.toggle('active', active);
    btn.innerHTML = heartSVG(active);
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  /* ── Inject heart button on product CARDS ── */
  function injectCardBtns() {
    document.querySelectorAll('.card-wrapper').forEach(function (wrapper) {
      if (wrapper.querySelector('.lenz-wl-btn:not(.lenz-wl-btn--product)')) return;
      var link = wrapper.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = link.href.match(/\/products\/([^?#/]+)/);
      if (!m) return;
      var handle = m[1];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lenz-wl-btn';
      btn.dataset.handle = handle;
      refreshBtn(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        WL.toggle(handle);
        document.querySelectorAll('.lenz-wl-btn[data-handle="' + handle + '"]').forEach(refreshBtn);
        dispatchChange();
      });
      /* Inject into card__inner (image ratio box) so it sits above the image */
      var target = wrapper.querySelector('.card__inner') || wrapper;
      target.appendChild(btn);
    });
  }

  /* ── Inject button on PRODUCT PAGE ── */
  function injectProductPageBtn() {
    if (window.location.pathname.indexOf('/products/') < 0) return;
    if (document.querySelector('.lenz-wl-btn--product')) return;
    var m = window.location.pathname.match(/\/products\/([^?#/]+)/);
    if (!m) return;
    var handle = m[1];
    var target = document.querySelector('.product-form__buttons');
    if (!target) return;
    var active = WL.has(handle);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lenz-wl-btn lenz-wl-btn--product' + (active ? ' active' : '');
    btn.dataset.handle = handle;
    btn.innerHTML = heartSVG(active) + '<span>' + (active ? 'Saved to Wishlist' : 'Save to Wishlist') + '</span>';
    btn.addEventListener('click', function () {
      var nowActive = WL.toggle(handle);
      btn.classList.toggle('active', nowActive);
      btn.innerHTML = heartSVG(nowActive) + '<span>' + (nowActive ? 'Saved to Wishlist' : 'Save to Wishlist') + '</span>';
      dispatchChange();
    });
    target.parentNode.insertBefore(btn, target.nextSibling);
  }

  /* ── Header wishlist icon ── */
  function updateBadge() {
    var count = WL.count();
    document.querySelectorAll('.lenz-wl-badge').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function injectHeaderIcon() {
    var count = WL.count();
    var iconHTML = '<a href="/pages/wishlist" class="lenz-wl-header-icon" aria-label="Wishlist">' +
      heartSVG(false) +
      '<span class="lenz-wl-badge" style="display:' + (count > 0 ? 'flex' : 'none') + '">' + count + '</span>' +
      '</a>';

    /* Insert once into head_icon_bottom — placeIcons() will move it to header_location on desktop */
    var icons = document.querySelector('.head_icon_bottom .header__icons');
    if (icons && !icons.querySelector('.lenz-wl-header-icon')) {
      icons.insertAdjacentHTML('afterbegin', iconHTML);
    }

    /* Re-run placeIcons so the icon is moved to the right container for the current viewport */
    if (typeof window.lenzPlaceIcons === 'function') window.lenzPlaceIcons();
  }

  /* ── Money formatter ── */
  function formatMoney(cents, moneyFormat) {
    var amount = (cents / 100).toFixed(2);
    if (moneyFormat) {
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    return 'QAR ' + amount;
  }

  function escHtml(str) {
    return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ── Wishlist PAGE renderer ── */
  function renderWishlistPage() {
    var container = document.getElementById('lenz-wishlist-page');
    if (!container) return;
    var moneyFormat = container.dataset.moneyFormat || '';
    var handles = WL.get();

    if (handles.length === 0) {
      container.innerHTML = '<div class="lenz-wl-empty">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
        '<h3>Your wishlist is empty</h3>' +
        '<p>Browse our store and click the heart icon on any product to save it here.</p>' +
        '<a href="/collections/all" class="button button--primary">Shop Now</a>' +
        '</div>';
      return;
    }

    container.innerHTML = '<div class="lenz-wl-loading">Loading your wishlist</div>';
    var products = [];
    var pending = handles.length;

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (product) products.push(product);
          else WL.remove(handle);
          pending--;
          if (pending === 0) renderGrid(container, products, handles, moneyFormat);
        })
        .catch(function () {
          WL.remove(handle);
          pending--;
          if (pending === 0) renderGrid(container, products, handles, moneyFormat);
        });
    });
  }

  function renderGrid(container, products, order, moneyFormat) {
    if (products.length === 0) { renderWishlistPage(); return; }
    products.sort(function (a, b) { return order.indexOf(a.handle) - order.indexOf(b.handle); });

    var html = '<div class="lenz-wl-grid">';
    products.forEach(function (p) {
      var img = p.images && p.images[0] ? p.images[0].replace(/(\.\w+)(\?.*)?$/, '_400x400$1') : '';
      var v = p.variants && p.variants[0];
      var price = v ? formatMoney(v.price, moneyFormat) : '';
      var compare = v && v.compare_at_price && v.compare_at_price > v.price ? formatMoney(v.compare_at_price, moneyFormat) : '';
      html += '<div class="lenz-wl-item">';
      html += '<a href="/products/' + p.handle + '" class="lenz-wl-item__image">';
      if (img) html += '<img src="' + img + '" alt="' + escHtml(p.title) + '" loading="lazy">';
      html += '</a>';
      html += '<div class="lenz-wl-item__info">';
      html += '<a href="/products/' + p.handle + '" class="lenz-wl-item__title">' + escHtml(p.title) + '</a>';
      html += '<div class="lenz-wl-item__price">';
      if (compare) html += '<s class="lenz-wl-compare">' + compare + '</s>';
      html += '<span>' + price + '</span></div>';
      html += '<div class="lenz-wl-item__actions">';
      html += '<a href="/products/' + p.handle + '" class="button button--primary lenz-wl-addcart">View Product</a>';
      html += '<button type="button" class="lenz-wl-remove" data-handle="' + p.handle + '" aria-label="Remove from wishlist">' + heartSVG(true) + '</button>';
      html += '</div></div></div>';
    });
    html += '</div>';
    container.innerHTML = html;

    container.querySelectorAll('.lenz-wl-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        WL.remove(btn.dataset.handle);
        dispatchChange();
        renderWishlistPage();
      });
    });
  }

  /* ── Init ── */
  function init() {
    injectCardBtns();
    injectProductPageBtn();
    injectHeaderIcon();
    updateBadge();
    renderWishlistPage();

    /* Re-inject on dynamic DOM changes (infinite scroll, quick-view, etc.) */
    var obs = new MutationObserver(function () { injectCardBtns(); });
    obs.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('lenz:wishlist:change', updateBadge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.LenzWishlist = WL;
})();
